<template>

  <b-card no-body>
    <b-row
      align-v="stretch"
      class="setting__lists"
    >
      <b-col
        v-for="setting in settings"
        :key="setting.title"
        cols="12"
        sm="6"
      >
        <SettingComponent
          :header-title="setting.title"
          :setting-key="setting.key"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import SettingComponent from '@/components/settings/accounts-settings/SettingComponent'

export default {
  components: {
    SettingComponent,
  },
  data() {
    return {
      settings: [
        { title: 'SEXY', key: 'casino.sexy' },
        { title: 'SAGAME', key: 'casino.sa' },
        { title: 'PRAGMATICPLAY', key: 'casino.casino_pragmaticplay' },
        { title: 'DREAMGAME', key: 'casino.dreamgame' },
        { title: 'PRETTYGAMING', key: 'casino.prettygaming' },
        { title: 'CQ9', key: 'casino.casino_cq9' },
        { title: 'ALLBET', key: 'casino.allbet' },
        { title: 'EBET', key: 'casino.ebet' },
        { title: 'CASINOGROUPSAPI', key: 'casino.casinogroupsapi' },
      ],
    }
  },
}
</script>

<style>

</style>
